<template>
  <div v-if="linked && (linked.error || waiting || paused)" class="watch-workout-sync" role="status" aria-live="polite">
    <v-progress-circular v-if="waiting && !linked.error" indeterminate size="16" width="2" color="success" />
    <span>{{ linked.error || (paused ? 'Training auf der Uhr pausiert' : 'Eingabe wird mit der Uhr abgeglichen …') }}</span>
    <template v-if="linked.conflict">
      <v-btn small text @click="resolve(true)">Handy-Eingabe</v-btn>
      <v-btn small text @click="resolve(false)">Uhr-Eingabe</v-btn>
    </template>
    <v-btn v-else-if="linked.error && linked.pending" small text @click="retry">Erneut abgleichen</v-btn>
    <v-btn v-else-if="linked.error" small text @click="resolve(false)">Uhr-Stand laden</v-btn>
  </div>
</template>
<script>
import watchWorkoutLink from "@/services/watchWorkoutLink"
export default {
  data: () => ({ waiting: false, delay: null }),
  computed: {
    linked() { return this.$store.state.runWorkoutStore.linkedWatchWorkout },
    pendingId() { return this.linked?.pending?.requestId },
    paused() { return this.$store.state.runWorkoutStore.liveSession?.phase === "paused" },
  },
  watch: {
    pendingId: { immediate: true, handler(value) {
      clearTimeout(this.delay); this.waiting = false
      if (value) this.delay = setTimeout(() => { this.waiting = true }, 700)
    } },
  },
  beforeDestroy() { clearTimeout(this.delay) },
  methods: {
    retry() { watchWorkoutLink.sharedError(null); watchWorkoutLink.sendShared(true) },
    resolve(phone) { try { watchWorkoutLink.resolveShared(phone) } catch (error) { this.$toast.error(error.message) } },
  },
}
</script>
<style scoped>
.watch-workout-sync { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; padding: 10px 16px; font-size: 12px; color: #d9e6df; background: #15221b; }
.watch-workout-sync > span { flex: 1; min-width: 180px; }
</style>
